import map from 'lodash/map';
import each from 'lodash/each';
import range from 'lodash/range';

import {
  getReducedFractionFromFloat
} from 'zoomforth_zfutils/fractions.js';

export const toTileAspectRatioString = ({ sizex, sizey })=>
  `${sizex}x${sizey}`;

export const toTrueTileAspectRatioString = ({ sizex, sizey })=>
  `${sizex}:${sizey}`;

export const fromTileAspectRatioString = (strn)=> {
  const [sizex,sizey] = map(strn.split('x'), n => Number(n));
  return { sizex, sizey };
};

export const fromTrueTileAspectRatioString = (strn)=> {
  const [sizex,sizey] = map(strn.split(':'), n => Number(n));
  return { sizex, sizey };
};

// These margin and padding factors are important for determining true aspect
// ratios. DO NOT change them since image aspect ratios are very specifically
// tied to these sizes
export const DESKTOP_TILE_MARGIN_FACTOR = 0.018;  // out of 1
export const DESKTOP_TILE_PADDING_FACTOR = 0.019; // out of 1  

/**
 * Determine an aspect ratio dimensions true value when taking into account
 * gutters that are spanned when creating tiles larger than 1:1.
 *
 * @param val int
 *
 * @return number
 */
export const getValueWithGutterAdjustment = (val)=>
  val + (((val - 1) * (DESKTOP_TILE_MARGIN_FACTOR + DESKTOP_TILE_PADDING_FACTOR)) * 2);

export const MINIMUM_NUMBER_COLUMNS = 1;
export const MAXIMUM_NUMBER_COLUMNS = 30;

/**
 * Determine the true aspect ratio of dimensions based on tiles which have been
 * scaled using the set margin and padding factors. This allows us to get the
 * best possible ratio for the actual sizing of the tiles themselves rather
 * than the grid positions they occupy.
 */
const calcTrueAspectRatio = (x, y) => {
  const { numerator, denominator } = getReducedFractionFromFloat(
    getValueWithGutterAdjustment(x) / getValueWithGutterAdjustment(y)
  );

  return `${numerator}:${denominator}`;
};

const aspectRatioToTrueAspectRatioMap = {};

each(range(MINIMUM_NUMBER_COLUMNS, MAXIMUM_NUMBER_COLUMNS + 1), (x)=> {
  each(range(MINIMUM_NUMBER_COLUMNS, MAXIMUM_NUMBER_COLUMNS + 1), (y)=> {
    aspectRatioToTrueAspectRatioMap[`${x}x${y}`] = calcTrueAspectRatio(x, y);
  });
});


export const getTrueTileAspectRatio = ({ sizex, sizey })=> {
  var trueAspectRatioString = aspectRatioToTrueAspectRatioMap[`${sizex}x${sizey}`];

  if (!trueAspectRatioString) {
    // If we do not have a pre-calculated value we calculate it on the fly
    trueAspectRatioString = calcTrueAspectRatio(sizex, sizey);
  }

  return fromTrueTileAspectRatioString(trueAspectRatioString);
};
